import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Wordmark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { InstallButton } from "@/components/InstallPWA";

const LINKS = [
  { to: "/discover", label: "Discover" },
  { to: "/discover?tab=briefs", label: "Briefs" },
  { to: "/events", label: "Events" },
  { to: "/opportunity-calendar", label: "Calendar" },
  { to: "/map", label: "Map" },
  { to: "/valuation", label: "Valuation" },
  { to: "/news", label: "News" },
  { to: "/awards", label: "Awards" },
];

export default function Nav() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-2xl bg-[#FFF7FB]/85 border-b border-[#2A1240]/10" data-testid="site-nav">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link"><Wordmark /></Link>
        <nav className="hidden xl:flex items-center gap-5">
          {LINKS.map((l) => (
            <NavLink key={l.label} to={l.to} data-testid={`nav-${l.label.toLowerCase()}-link`}
              className="text-sm text-slate-300 hover:text-[#2A1240] transition-colors relative group">
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#E0218A] transition-[width] duration-500 group-hover:w-full" />
            </NavLink>
          ))}
        </nav>
        <div className="hidden xl:flex items-center gap-3">
          <InstallButton />
          {user ? (
            <button onClick={() => nav("/app")} className="btn-gold !py-2.5" data-testid="nav-dashboard-button">
              Dashboard <ArrowUpRight className="h-4 w-4" />
            </button>
          ) : (
            <>
              <Link to="/login" className="text-sm text-slate-200 hover:text-[#2A1240] px-3" data-testid="nav-login-link">Sign in</Link>
              <Link to="/register" className="btn-gold !py-2.5" data-testid="nav-join-button">Join free</Link>
            </>
          )}
        </div>
        <button className="xl:hidden p-2 text-slate-100" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="xl:hidden border-t border-[#2A1240]/10 bg-[#FFF7FB] px-5 py-4 flex flex-col max-h-[calc(100vh-4rem)] overflow-y-auto" data-lenis-prevent data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="py-3 border-b border-[#2A1240]/10 text-lg font-semibold text-[#2A1240]">{l.label}</Link>
          ))}
          <div className="mt-4 flex flex-col gap-3"><InstallButton /></div>
          {user ? (
            <Link to="/app" className="btn-gold mt-3" onClick={() => setOpen(false)} data-testid="nav-mobile-dashboard">Dashboard</Link>
          ) : (
            <div className="mt-3 flex gap-3">
              <Link to="/login" className="btn-ghost flex-1" data-testid="nav-mobile-login">Sign in</Link>
              <Link to="/register" className="btn-gold flex-1" data-testid="nav-mobile-join">Join</Link>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
